import React, {Component} from "react";
import AppSidebar from "../../components/AppSidebar";
import PageHeader from "../../components/PageHeader";
import ActionButton from "../../components/ActionButton";
import PanelGroupController from "../../components/PanelGroupController";
import ShopPropertiesPanel from "./panels/ShopPropertiesPanel";
import PricingPanel from "./panels/PricingPanel";
import ShopLocationsPanel from "./panels/ShopLocationsPanel";
import ProductsList from "./views/ProductsList";
import SubscriptionProductsList from "./views/SubscriptionProductsList";
import ShopsList from "./views/ShopsList";
import ShopSurchargesList from "./views/ShopSurchargesList";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import ProductPropertiesPanel from "../products/panels/ProductPropertiesPanel";
import {List} from "immutable";

class ShopsPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetShopSelection = this.handleSetShopSelection.bind(this);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.handleSetSubscriptionSelection = this.handleSetSubscriptionSelection.bind(this);
    this.handleViewShopId = this.handleViewShopId.bind(this);
    this.handleSurchargeSelection = this.handleSurchargeSelection.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.state = {
      productId: "",
      hasShopSelection: false,
      hasProductSelection: false,
      hasSubscriptionSelection: false,
      subscriptionId: "",
      filterShopId: "all",
    }
  }

  render() {
    const {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />

    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = "Shops";
    if (page === "shop") {
      title = `${title} / ${this.props.params.shopId}`;
    }

    return (
      <div className="ShopsPage SecurePage">
        <AppSidebar />
        <PageHeader title={title} backButton={page === "shop"} onBack={this.handleBack}/>
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header" />
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton
              label="Add Product to Shop"
              active={false}
              show={false}
              onClick={this.handleAddProductToShop.bind(this)}
              />
            <ActionButton
              label="Remove From Shop"
              active={false}
              show={false}
              onClick={this.handleRemoveProductFromShop.bind(this)}
              />
            <ActionButton
              label="Change Subscription Price"
              active={this.state.hasSubscriptionSelection}
              show={page === "shop"}
              onClick={this.handleChangeSubscriptionPricing.bind(this)}
              />
            <ActionButton
              label="Commit Subscription Pricelist"
              active={true}
              show={page === "shop"}
              onClick={this.handleCommitSubscriptionPricelist.bind(this)}
              />
            <ActionButton
              label="Change Product Price"
              active={this.state.hasProductSelection}
              show={page === "shop"}
              onClick={this.handleChangePricing.bind(this)}
              />
            <ActionButton
              label="Commit Product Pricelist"
              active={true}
              show={page === "shop"}
              onClick={this.handleCommitProductPricelist.bind(this)}
              />
            <ActionButton
              label="Apply Product Surcharge"
              active={this.state.hasProductSelection}
              show={page === "shop"}
              onClick={this.handleApplyProductSurcharge.bind(this)}
              />
          </PanelGroupController>
        </div>
      </div>
    )
  }

  renderView(page) {
    switch(page) {
      case "shops":
        return <ShopsList
                key="ShopsList" 
                selectedId={this.props.params.shopId}
                onShopIdClick={this.handleViewShopId}
                onSelectionChange={this.handleSetShopSelection}
                />

      default:
        return <React.Fragment>
                  <SubscriptionProductsList 
                    key="SubscriptionProductsList"
                    shopId={this.props.params.shopId}
                    selectedProductId={this.state.subscriptionId} 
                    onSelectionChange={this.handleSetSubscriptionSelection}
                    />
                  <ProductsList 
                    key="ProductsList"
                    shopId={this.props.params.shopId}
                    selectedProductId={this.state.productId} 
                    onSelectionChange={this.handleSetSelection}
                    />
                  <ShopSurchargesList 
                    key="ShopSurchargesList" 
                    shopId={this.props.params.shopId}
                    onSelectionChange={this.handleSurchargeSelection}
                    />
                </React.Fragment>
    }
  }

  renderPanels(page) {
    switch(page) {
      case "shops": 
        return this.buildPanels(List([ShopPropertiesPanel]));
      default:
        return this.buildPanels(List([ShopPropertiesPanel, ProductPropertiesPanel, PricingPanel, ShopLocationsPanel]));
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case ShopPropertiesPanel:
        return <ShopPropertiesPanel
                key="ShopPropertiesPanel"
                expanded={true}
                shopId={this.props.params.shopId}
                />
      case ProductPropertiesPanel:
        return <ProductPropertiesPanel
                key="ProductPropertiesPanel"
                expanded={false}
                productId={this.state.productId}
                hasSelection={this.state.hasProductSelection}
                />
      case PricingPanel:
        return <PricingPanel
                key="PricingPanel"
                expanded={true}
                shopId={this.props.params.shopId}
                productId={this.state.productId}
                active={this.state.hasProductSelection}
                />
      case ShopLocationsPanel:
        return <ShopLocationsPanel
                key="ShopLocationsPanel"
                expanded={false}
                shopId={this.props.params.shopId}
                active={true}
                requestChangeAvailabilityForLocation={this.props.requestChangeAvailabilityForLocation}
                />


      default:
        return null;      
    }
  }

  handleViewShopId(shopId) {
    this.setState({shopId: shopId}) 
    this.props.router.push(`/shops/${shopId}`);        
  }

  handleSetShopSelection(shopId) {
    this.setState({shopId: shopId, hasShopSelection: true})
  }

  handleSetSelection(productId, shopId) {
    this.setState({productId: productId, hasProductSelection: true});
  }

  handleSetSubscriptionSelection(productId, shopId) {
    this.setState({subscriptionId: productId, hasSubscriptionSelection: true});
  }

  handleSurchargeSelection(e, item) {
    this.props.requestEditProductSurcharge(item.get("shopId"), item.get("productSku"), item.get("countryCode"), item.get("stateCode"));
  }

  handleAddProductToShop(e, shop) {
    this.props.requestAddProductToShop(this.props.params.shopId, this.props.params.shopId);
  }

  handleRemoveProductFromShop() {
    this.props.requestRemoveProductFromShop(this.props.params.shopId, this.state.productId);
  }

  handleChangePricing() {
    this.props.requestChangeProductPricing(this.props.params.shopId, this.state.productId);
  }

  handleChangeSubscriptionPricing() {
    this.props.requestChangeSubscriptionProductPricing(this.props.params.shopId, this.state.subscriptionId);
  }

  handleCommitProductPricelist() {
    this.props.requestCommitProductPricelist(this.props.params.shopId);
  }

  handleCommitSubscriptionPricelist() {
    this.props.requestCommitSubscriptionPricelist(this.props.params.shopId);
  }

  handleShopsFilterChange(shopId) {
    this.setState({filterShopId: shopId});
  }

  handleApplyProductSurcharge() {
    this.props.requestApplyProductSurcharge(this.props.params.shopId, this.state.productId);
  }

  handleBack() {
    this.props.router.push(`/shops`);
  }    

}

export default ShopsPage;